import React from "react";
import DefaultDescription from "./DefaultDescription";
import ConvertibleDescription from "./ConvertibleDescription";

const Description = ({ size }) => {
  if(size.type !== "Convertible") {
    return <DefaultDescription size={size} />;
  } else {
    return <ConvertibleDescription size={size} />;
  }
};

Description.propTypes = {
  size: React.PropTypes.object.isRequired
};

export default Description;


/** WEBPACK FOOTER **
 ** ./src/components/AvailableSizes/CarSeatsContainer/Descriptions/Description.js
 **/